import { Typography } from "@lyfegen-platform/react-common";
import { Box, Theme } from "@material-ui/core";
import { CaseFormStatus } from "../../../containers/cases/details/FormCard";
import { FlexFormStatus } from "../../../types/graphql-global-types";
import { formStatusToColor, getFormStatusIcon } from "../utils/status";

interface FormStatusProps {
	props: any;
	children: React.ReactNode;
	palette: Theme["palette"];
	t: any;
}

function resolveStatus(
	status: FlexFormStatus | undefined,
	caseFormStatus: CaseFormStatus | undefined
): FlexFormStatus | "due" | "overdue" | undefined {
	return caseFormStatus === "due" || caseFormStatus === "overdue" ? caseFormStatus : status;
}

const Text: React.FC<FormStatusProps> = ({ props, palette, t }) => (
	<Typography
		type="status"
		style={{
			marginLeft: "2px",
			color: formStatusToColor(resolveStatus(props?.status, props?.caseFormStatus), palette, true),
		}}
	>
		{t(resolveStatus(props?.status, props?.caseFormStatus))}
	</Typography>
);

const FormStatus: React.FC<FormStatusProps> = ({ props, children, palette, t }) => {
	const status = resolveStatus(props?.status, props?.caseFormStatus);

	return (
		<Box
			display="flex"
			alignItems="center"
			justifyContent={"start"}
			style={{
				height: "22px",
				borderRadius: "100px",
				backgroundColor: formStatusToColor(resolveStatus(props?.status, props?.caseFormStatus), palette),
				padding: "3px 8px 3px 6px",
				fontWeight: 600,
				maxWidth: "fit-content",
			}}
		>
			{status && getFormStatusIcon(status)}
			<Text props={props} palette={palette} t={t} children={children} />
		</Box>
	);
};

export default FormStatus;
